<script lang="ts" setup>
const props = defineProps<{
  opened: boolean;
}>();

const { eventGuest } = storeToRefs(useEventGuestStore());
const { supportsRsvp } = usePackageCapabilities();
const musicRef = useTemplateRef("music");

function onToggleMusic() {
  musicRef.value?.onTogglePlay();
}

defineExpose({
  onToggleMusic,
});
</script>

<template>
  <div class="flex flex-col gap-4 fixed right-6 bottom-8 z-5 xl:right-10">
    <LazyUiRsvpButton
      v-if="supportsRsvp && eventGuest?.status === 'unconfirmed'"
      :opened="props.opened"
    />
    <LazyPFloatingButtonMusic
      ref="music"
    />
  </div>
</template>
